module.exports = __webpack_public_path__ + "media/images/badge-offset-7e248c8ed1111e94b4fd265aac306765.svg";